
import {createSlice} from '@reduxjs/toolkit'
import { fetchjobstatus } from '../../action/master/jobstatusAction'

interface jobstatusState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: jobstatusState = {
  data: null,
  status: 'idle',
  error: null,
}

const jobstatusSlice = createSlice({
  name: 'jobstatus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchjobstatus.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchjobstatus.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchjobstatus.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default jobstatusSlice.reducer
